import type { Dispatch, SetStateAction } from 'react'

import { useEffect, useState } from 'react'
import { useDebounce } from 'react-use'

interface Options {
  time?: number
}

type setFilters <T extends Record<string, unknown>> = Dispatch<SetStateAction<T>>
type setDebouncedFilters <T extends Record<string, unknown>> = setFilters<T>

export function useDebouncedFilters <T extends Record<string, unknown>> (initialFilters: T, options?: Options): [T, T, setFilters<T>, setDebouncedFilters<T>] {
  const [ filters, setFilters ] = useState<T>(initialFilters)
  const [ debouncedFilters, setDebouncedFilters ] = useState<T>(initialFilters)

  useDebounce(() => {
    setDebouncedFilters(filters)
  }, options?.time ?? 1000, [ filters ])

  useEffect(() => {
    setFilters(debouncedFilters)
  }, [ debouncedFilters ])

  useEffect(() => {
    setFilters(initialFilters)
  }, [ initialFilters ])

  return [ debouncedFilters, filters, setFilters, setDebouncedFilters ]
}
